<template>
  <div class="login">
    <div class="container" v-if="!errorMessage">
      <!-- 加载状态 -->
      <div class="loading" v-if="isLoading">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>

      <!-- 登录内容 -->
      <div v-else>
        <div class="news">
          <!-- <div class="head">{{ nickName }}</div> -->
          <div class="text">Please enter the 4-digit verification code to view the message</div>
        </div>
        <div class="password-container">
          <img src="../../assets/y.jpg" style="margin-bottom: 10px" />
          <input
              v-for="(_, index) in 4"
              :key="index"
              ref="input"
              maxlength="1"
              v-model="codes[index]"
              autocomplete="off"
              type="tel"
              inputmode="numeric"
              @input="handleInput(index, $event)"
              @keydown.delete="handleDelete(index, $event)"
              @paste.prevent="handlePaste"
              class="password-input"
          />
        </div>
        <div class="error-container" v-if="loginErrorMessage">
          <div class="error-text">{{ loginErrorMessage }}</div>
        </div>
      </div>
    </div>

    <!-- 错误信息 -->
    <div class="error-container" v-if="errorMessage">
      <div class="error-text">{{ errorMessage }}</div>
    </div>
<!--    <footer class="footer">-->
<!--      <a class="link" href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024082659号-3</a>-->
<!--    </footer>-->
  </div>
</template>

<script>
import {checkRandomPath, getTokenByValidCode, queryReplyInterval} from '../../api/apis'
import { save } from '../../storage/session'
export default {
  data() {
    return {
      codes: ['', '', '', ''],
      nickName: '',
      randomPath: '',
      isLoading: true,
      errorMessage: '',
      loginErrorMessage: ""
    }
  },
  mounted() {
    this.randomPath = this.$route.params.randomPath
    // 调用checkRandomPath并处理返回结果
    checkRandomPath({ randomPath: this.randomPath }).then(() => {
      this.isLoading = false
      // success为true，进行后续逻辑处理
      if (this.$route.query.nickName) {
        if (this.$route.query.nickName.length > 2) {
          this.nickName = this.$route.query.nickName.substring(0, 2)
        } else {
          this.nickName = this.$route.query.nickName
        }
      }
    }).catch(() => {
      this.isLoading = false
      this.errorMessage = 'error'
    })
  },
  watch: {
    async codes(newval) {
      const r = newval.every((item) => item)
      this.loginErrorMessage = ""
      if (r) {
        try {
          let validCode = ''
          newval.forEach((item) => (validCode += item))
          const res = await getTokenByValidCode({ validCode,  randomPath: this.randomPath})
          if (res.success) {
            save('token', res.data.token)
            save('number', res.data.number)
            save('nickName',res.data.nickName)
            save('otherNickName',res.data.otherNickName)
            const intervalRes = await queryReplyInterval()
            localStorage.setItem('interval', intervalRes.data*1000)
            this.$router.push('/app/message')
          } else {
            this.loginErrorMessage = 'Invalid or expired verification code.'
          }
        }catch (e){
          console.error(e)
          this.loginErrorMessage = 'Invalid or expired verification code.'
        }
      }
    }
  },
  methods: {
    handleInput(index, event) {
      if (event.target.value) {
        this.codes[index] = event.target.value.slice(0, 1) // 确保只取第一个字符
        if (index < 3) {
          this.$nextTick(() => {
            this.$refs.input[index + 1].focus()
          })
        }
      }
    },
    handleDelete(index, event) {
      if (!event.target.value && index > 0) {
        this.$refs.input[index - 1].focus()
      }
    },
    handlePaste(e) {
      const pasteData = e.clipboardData.getData('text').slice(0, 4)
      pasteData.split('').forEach((char, i) => {
        if (i < 4) {
          this.codes[i] = char
        }
      })
      this.$nextTick(() => {
        const focusIndex = Math.min(pasteData.length, 3)
        this.$refs.input[focusIndex].focus()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  height: 300px;
}
.password-container {
  display: flex;
  gap: 30px;
  justify-content: center;
  align-items: center;
}
.news {
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  padding: 0 20px;
}
.head {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 8px;
  object-fit: cover;
  background-color: #ddd;
  flex-shrink: 0;
  margin-right: 20px;
  color: #fff;
  line-height: 40px;
  text-align: center;
}
.text {
  margin-top: 10px;
}

.password-input {
  width: 50px;
  height: 50px;
  text-align: center;
  font-size: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s;
}

.password-input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

/* Loading样式 */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(64, 158, 255, 0.2);
  border-radius: 50%;
  border-top-color: #409eff;
  animation: spin 1s ease-in-out infinite;
}

.loading-text {
  margin-top: 16px;
  color: #606266;
}
.footer {
  .link {
    font-size: 12px;
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    text-decoration: none;
    color: #000000;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-container {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-text {
  color: red;
  font-size: 14px;
}



@media (max-width: 768px) {
  .password-container {
    gap: 15px;
    img {
      width: 50px;
      height: auto;
    }
    .password-input {
      width: 35px;
      height: 35px;
    }
  }
}
</style>
